import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface HeroSectionProps {
  className?: string;
}

const HeroSection = ({ className = '' }: HeroSectionProps) => {
  return (
    <section className={`relative min-h-[60vh] flex items-center justify-center bg-gradient-to-b from-surface to-background ${className}`}>
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-10 left-10 w-32 h-32 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-20 w-40 h-40 bg-secondary/5 rounded-full blur-3xl" />
      </div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 mb-6 bg-primary/10 rounded-full">
          <Icon name="HeartIcon" size={32} className="text-primary" variant="solid" />
        </div>
        
        <h1 className="font-playfair text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground mb-4">
          Our Love Story
        </h1>
        
        <p className="font-inter text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto mb-8">
          A testament to God's perfect timing and divine orchestration
        </p>
        
        <div className="inline-flex items-center space-x-2 px-6 py-3 bg-card rounded-full shadow-sacred-md">
          <Icon name="SparklesIcon" size={20} className="text-accent" variant="solid" />
          <p className="font-playfair text-sm italic text-foreground">
            "He has made everything beautiful in its time"
          </p>
          <span className="font-inter text-xs text-muted">— Ecclesiastes 3:11</span>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;